export default "__VITE_ASSET__BPHgRNXr__"